import React from 'react';
import { TextMediumdS, TextMediumXS } from '../../../../Components/Text/MediumText';
import NuDate from '../../../../Components/Utils/NuDate';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';
import { useNavigate } from 'react-router-dom';
import NuAmount from '../../../../Components/Utils/NuAmount';
import { GetAccess, GetUseRole } from '../../../../Components/Utils/roles';



function InvoiceDue() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/invoice-outgoing/due-report`);


  
const navigate = useNavigate();

  const handleSliceClick = (id) => {
    navigate( `/invoice/invoice-outgoing/view/${id}`, {
      state: { fromDashboard: true }
    });
 
 
};

const totalAmount = data?.reduce((acc, item) => {
  const cleanedAmount = parseFloat(item.amount.replace(/,/g, '')) || 0;
  return acc + cleanedAmount;
}, 0);

  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col">
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-sm  font-bold text-gray-800">
          Invoice In Due
        </h2>
         <div className="sm:mt-0 mt-1 h-6 border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
          <p className="w-20 bg-white text-black px-2 flex items-center justify-center">Total Amt</p>
          <p className="bg-baseColor-primary w-auto min-w-[3rem] text-white px-2 flex items-center justify-center">
            <NuAmount value={totalAmount} />
          </p>
        </div>
        <span className="bg-red-100 text-red-600 text-xs font-medium px-2 py-0.5 rounded-lg">
          Total : {data?.length || 0}
        </span>
      </div>
      <p className="text-gray-500 text-xs font-light mb-3">List in Invoices Due for Collection</p>

      <div className=" w-full h-[96%] overflow-y-scroll pb-4">
        <table className="w-full text-sm">
          <thead className="sticky top-0 z-10 bg-white shadow-sm">
            <tr className="text-gray-700 border-b">
              <th className="text-left px-2 py-2"><TextMediumXS content="Invoice No." /></th>
              {GetUseRole("client") ?(
                           <th className="text-left px-2 py-2"></th>

              ):(
                <th className="text-left px-2 py-2"><TextMediumXS content="Client" /></th>

              )} 
              <th className="text-left px-2 py-2"><TextMediumXS content="Amount" /></th>
              <th className="text-left px-2 py-2"><TextMediumXS content="Due Date" /></th>
              <th className="text-left px-2 py-2"><TextMediumXS content="Days Elapsed" /></th>
            </tr>
          </thead>
          <tbody>
            {data && data?.map((item, index) => (
              <tr
                className={`${
                  index % 2 === 0 ? 'bg-slate-50' : 'bg-white'
                } border-b hover:bg-slate-100 transition-all`}
                key={index}
              >
                <td className="px-2 py-2 cursor-pointer"  onClick={GetAccess('invoice_out_view')  ?() => handleSliceClick(item.id): undefined}
                >
                  <TextMediumdS content={item?.invoiceNo || "N/A"} />
                </td>
                {GetUseRole('client') ?(
              <td className="px-2 py-2">
             
            </td>
              ):(
                <td className="px-2 py-2">
                <TextMediumdS content={item?.client || "N/A"} />
              </td>
              )} 
               
                <td className="px-2 py-2">
  
  <TextMediumdS content={<NuAmount  value={item?.amount}/>} />

</td>
                <td className="px-2 py-2">
                <TextMediumdS content={item?.dueDate ? (
    <NuDate value={item.dueDate} format="DD MMM YYYY" />
  ) : (
    "N/A"
  )} />
                </td>
                <td className="px-2 py-2">
                <TextMediumdS
  content={
    <span
      className={`flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-lg ${
        item?.daysElapsed >= 30
          ? ' text-red-700'
          : ' text-gray-700'
      }`}
    >
      ⏱️ {item?.daysElapsed || 0} 
    </span>
  }
/>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default InvoiceDue;
